import React, { Component } from "react";
import PropTypes from "prop-types";
import { Flex, Box, Heading } from "rebass";
import { GET_ONE } from "admin-on-rest";
import { cyan500 } from "material-ui/styles/colors";
import ContainerDimensions from "react-container-dimensions";
import { RestClient } from "../../restClient";
import ResponsiveImage from "../../components/image/ResponsiveImage";
import ProductCard from "./ProductCard";
import { checkWidth } from "./utils";
import { CubeGrid } from "../../components/spinkit";

class Collections extends Component {
  constructor(props) {
    super(props);

    this.state = {
      collections: {},
      isLoading: true
    };
  }

  componentDidMount() {
    this.getCollections(this.props.collectionId);
  }

  getCollections(paramsId) {
    RestClient(GET_ONE, "collections", { id: paramsId })
      .then(items => {
        if (items && items.data) {
          this.setState({
            collections: items.data,
            isLoading: false
          });
        }
      })
      .catch(e => {
        // resolve([]);
        this.setState({
          isLoading: false
        });
      });
  }

  render() {
    const { collections, isLoading } = this.state;
    if (isLoading) {
      return (
        <div
          style={{
            display: "flex",
            height: "100%",
            flexDirection: "column",
            justifyContent: "center"
          }}
        >
          <Flex justify={["center"]} align={["center"]}>
            <CubeGrid size={80} color={cyan500} />
          </Flex>
        </div>
      );
    }
    let srcMobile =
      collections.banners && collections.banners.mobile
        ? collections.banners.mobile
        : "";
    let srcDesktop =
      collections.banners && collections.banners.desktop
        ? collections.banners.desktop
        : "";
    return (
      <Box w={[1]}>
        {(srcDesktop !== "" || srcMobile !== "") && (
          <Box w={[1]} py={[1, 2]}>
            <ResponsiveImage srcDesktop={srcDesktop} srcMobile={srcMobile} />
          </Box>
        )}
        {srcDesktop === "" &&
          srcMobile === "" && (
            <Box w={[1]} p={[2]}>
              <Heading center fontSize={["1.5em", "2em"]}>
                {collections.name}
              </Heading>
            </Box>
          )}
        {collections.products &&
          collections.products.length > 0 && (
            <Box w={[1]}>
              <div
                style={{
                  boxSizing: "border-box",
                  position: "relative",
                  height: "100%",
                  display: "flex",
                  flex: 1
                }}
              >
                <ContainerDimensions>
                  {({ width, height }) => {
                    return (
                      <Flex
                        wrap
                        ml={["0px", "0px", "0px", "-8px"]}
                        flex={["1"]}
                      >
                        {collections.products.map((product, index) => {
                          return (
                            <BoxCase
                              key={`box${index}`}
                              px={["4px", "4px", "4px", "4px"]}
                              py={["4px"]}
                            >
                              <ProductCard
                                product={product}
                                itemWidth={checkWidth(width)}
                              />
                            </BoxCase>
                          );
                        })}
                      </Flex>
                    );
                  }}
                </ContainerDimensions>
              </div>
            </Box>
          )}
      </Box>
    );
  }
}

const BoxCase = Flex.extend`
  position: relative;
  overflow: hidden;
  @media screen and (min-width: 52em) {
    width: 25%;
  }
  @media screen and (min-width: 60em) {
    width: 20%;
  }
`;

Collections.propTypes = {
  collectionId: PropTypes.number
};

export default Collections;



// WEBPACK FOOTER //
// ./src/campaigns/productlist/Collections.js